module.exports = __webpack_public_path__ + "static/media/hoojan-480x360.bc3f3408.png";